var _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 43,
    viewBox: "0 0 31 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0309 10.3408C29.4184 10.1621 29.4183 9.6113 29.0308 9.43264L23.5313 6.89727C23.3554 6.81595 23.2145 6.67411 23.1333 6.49781L20.6036 0.989883C20.4252 0.601463 19.8733 0.601462 19.6949 0.989883L17.1652 6.49781C17.084 6.67411 16.9425 6.81595 16.7672 6.89727L11.2677 9.43264C10.8801 9.6113 10.8801 10.1621 11.2676 10.3408L16.7672 12.8767C16.9425 12.9581 17.084 13.0998 17.1652 13.2755L19.6949 18.784C19.8732 19.1725 20.4252 19.1725 20.6036 18.784L23.1333 13.2755C23.2145 13.0998 23.3554 12.9581 23.5313 12.8767L29.0309 10.3408Z",
    fill: "#E6126A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4918 16.4815C11.8793 16.3028 11.8793 15.752 11.4917 15.5733L8.37618 14.137C8.26492 14.0856 8.17583 13.9959 8.12451 13.8844L6.69189 10.7652C6.5135 10.3768 5.96155 10.3768 5.78315 10.7652L4.35054 13.8844C4.29922 13.9959 4.20971 14.0856 4.09886 14.137L0.983295 15.5733C0.59576 15.752 0.595734 16.3028 0.983254 16.4815L4.09886 17.9182C4.20971 17.9696 4.29922 18.0592 4.35054 18.1703L5.78315 21.2899C5.96153 21.6783 6.51351 21.6783 6.6919 21.2899L8.12451 18.1703C8.17583 18.0592 8.26492 17.9696 8.37618 17.9182L11.4918 16.4815Z",
    fill: "#F15A29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4996 30.654C16.8871 30.4753 16.8871 29.9246 16.4996 29.7459L15.2867 29.1868C15.2271 29.1592 15.1793 29.1111 15.1518 29.0514L14.5948 27.8386C14.4164 27.4502 13.8645 27.4502 13.6861 27.8386L13.1291 29.0514C13.1016 29.1111 13.0536 29.1592 12.9942 29.1868L11.7813 29.7459C11.3938 29.9246 11.3938 30.4753 11.7813 30.654L12.9942 31.2133C13.0536 31.2409 13.1016 31.289 13.1291 31.3485L13.6861 32.5614C13.8644 32.9498 14.4164 32.9498 14.5948 32.5614L15.1518 31.3485C15.1793 31.289 15.2271 31.2409 15.2867 31.2133L16.4996 30.654Z",
    fill: "#005E9D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4415,
    cy: 41.6368,
    r: 1.3085,
    transform: "rotate(-180 22.4415 41.6368)",
    fill: "#7E3F97"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.40244,
    cy: 28.4845,
    r: 1.3085,
    transform: "rotate(-180 2.40244 28.4845)",
    fill: "#3EB5E5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8243,
    cy: 21.3282,
    r: 1.3085,
    transform: "rotate(-180 26.8243 21.3282)",
    fill: "#143860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.00368f01276c7b98ef54b00e5a04026c.svg";
export { ForwardRef as ReactComponent };